/**
 * Header V2 交互逻辑
 * - Hover/Click 展开下拉菜单
 * - 点击外部关闭下拉菜单
 * - 支持键盘导航
 */

(function () {
    'use strict';

    const header = document.querySelector('[data-header-v2]');
    if (!header) return;

    const menuItems = header.querySelectorAll('.header-v2__menu-item');
    const dropdownTriggerType = header.dataset.dropdownTrigger || 'hover';
    const overlay = document.querySelector('[data-dropdown-overlay]');

    // 动态计算并设置 header 高度
    function updateHeaderHeight() {
        const headerWrapper = header.querySelector('.header-v2__wrapper');
        if (headerWrapper) {
            const rect = headerWrapper.getBoundingClientRect();
            const headerHeight = Math.max(rect.bottom, rect.height);
            document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        }
    }

    // 初始化和窗口调整时更新高度
    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);
    window.addEventListener('scroll', updateHeaderHeight);

    let closeTimer = null; // 延迟关闭定时器

    // 更新遮罩层状态
    function updateOverlay() {
        const hasOpenDropdown = Array.from(menuItems).some(
            item => item.getAttribute('aria-expanded') === 'true'
        );

        if (overlay) {
            overlay.classList.toggle('active', hasOpenDropdown);
        }
    }

    // 关闭所有下拉菜单
    function closeAllDropdowns() {
        menuItems.forEach(item => {
            item.setAttribute('aria-expanded', 'false');
        });
        updateOverlay();
    }

    // 切换下拉菜单
    function toggleDropdown(menuItem, forceState) {
        const currentState = menuItem.getAttribute('aria-expanded') === 'true';
        const newState = forceState !== undefined ? forceState : !currentState;

        // 关闭其他下拉菜单
        if (newState) {
            closeAllDropdowns();
        }

        menuItem.setAttribute('aria-expanded', newState);
        updateOverlay();
    }

    // 为每个菜单项添加交互
    menuItems.forEach(menuItem => {
        const hasDropdown = menuItem.hasAttribute('data-has-dropdown');
        if (!hasDropdown) return;

        const menuLink = menuItem.querySelector('.header-v2__menu-link');
        const dropdown = menuItem.querySelector('.header-v2__dropdown');
        if (!menuLink) return;

        if (dropdownTriggerType === 'hover') {
            // Hover 模式 - 添加延迟关闭逻辑
            menuItem.addEventListener('mouseenter', () => {
                // 清除之前的关闭定时器
                if (closeTimer) {
                    clearTimeout(closeTimer);
                    closeTimer = null;
                }
                toggleDropdown(menuItem, true);
            });

            menuItem.addEventListener('mouseleave', () => {
                // 延迟 300ms 关闭，给用户时间移动到下拉菜单
                closeTimer = setTimeout(() => {
                    toggleDropdown(menuItem, false);
                }, 300);
            });

            // 如果鼠标进入下拉菜单，取消关闭
            if (dropdown) {
                dropdown.addEventListener('mouseenter', () => {
                    if (closeTimer) {
                        clearTimeout(closeTimer);
                        closeTimer = null;
                    }
                });

                dropdown.addEventListener('mouseleave', () => {
                    closeTimer = setTimeout(() => {
                        toggleDropdown(menuItem, false);
                    }, 300);
                });
            }

            // 点击时跳转到链接
            menuLink.addEventListener('click', (e) => {
                const href = menuLink.getAttribute('href');
                if (href && href !== '#') {
                    return;
                }
                e.preventDefault();
            });
        } else {
            // Click 模式
            menuLink.addEventListener('click', (e) => {
                e.preventDefault();
                toggleDropdown(menuItem);
            });
        }

        // 键盘支持
        menuLink.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                toggleDropdown(menuItem);
            } else if (e.key === 'Escape') {
                toggleDropdown(menuItem, false);
            }
        });
    });

    // 点击遮罩层关闭下拉菜单
    if (overlay) {
        overlay.addEventListener('click', () => {
            closeAllDropdowns();
        });
    }

    // 点击外部关闭下拉菜单
    document.addEventListener('click', (e) => {
        if (!header.contains(e.target) && !overlay.contains(e.target)) {
            closeAllDropdowns();
        }
    });

    // ESC 键关闭所有下拉菜单
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeAllDropdowns();
        }
    });

})();

/**
 * 移动端抽屉和手风琴菜单
 */
(function () {
    'use strict';

    const drawerTrigger = document.querySelector('[data-drawer-trigger]');
    const drawerOverlay = document.querySelector('[data-drawer-overlay]');
    const drawerClose = document.querySelector('[data-drawer-close]');
    const drawerContent = document.querySelector('[data-drawer-content]');
    const drawerPanel = document.querySelector('[data-drawer]');

    if (!drawerTrigger || !drawerOverlay) return;

    // 打开抽屉
    function openDrawer() {
        drawerOverlay.classList.add('active');
        document.body.style.overflow = 'hidden'; // 禁止背景滚动
    }

    // 关闭抽屉
    function closeDrawer() {
        drawerOverlay.classList.remove('active');
        document.body.style.overflow = '';
    }

    // 事件监听
    drawerTrigger.addEventListener('click', openDrawer);
    drawerClose?.addEventListener('click', closeDrawer);

    // 点击遮罩关闭
    drawerOverlay.addEventListener('click', (e) => {
        const clickedOverlay = e.target === drawerOverlay;
        const clickedOutsidePanel = drawerPanel && !drawerPanel.contains(e.target);

        if (clickedOverlay || clickedOutsidePanel) {
            closeDrawer();
        }
    });

    // ESC 键关闭
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawerOverlay.classList.contains('active')) {
            closeDrawer();
        }
    });

    // 手风琴菜单 - 点击整行触发
    const menuItemRows = document.querySelectorAll('.mobile-menu-item__row');

    menuItemRows.forEach(row => {
        row.addEventListener('click', (e) => {
            const menuItem = row.closest('.mobile-menu-item');
            const toggleButton = row.querySelector('[data-toggle]');
            const link = row.querySelector('.mobile-menu-item__link');

            // 如果有展开按钮（即有子菜单）
            if (toggleButton) {
                // 阻止链接跳转
                e.preventDefault();

                const targetId = toggleButton.dataset.toggle;
                const content = document.querySelector(`[data-content="${targetId}"]`);

                if (!content) return;

                const isActive = toggleButton.classList.contains('active');

                // 切换状态
                toggleButton.classList.toggle('active');
                content.classList.toggle('active');

                // 更新 ARIA
                toggleButton.setAttribute('aria-expanded', !isActive);

                // 展开底边距逻辑：展开时隐藏下方菜单项
                if (menuItem) {
                    handleExpandedMenuScroll(menuItem, content, !isActive);
                }
            }
            // 如果没有子菜单，让链接正常跳转（不阻止默认行为）
        });
    });

    // 保留原有的 toggle 按钮点击事件（点击 + 按钮也能触发）
    const toggleButtons = document.querySelectorAll('[data-toggle]');

    toggleButtons.forEach(button => {
        button.addEventListener('click', (e) => {
            // 阻止事件冒泡，避免触发两次
            e.stopPropagation();

            const targetId = button.dataset.toggle;
            const content = document.querySelector(`[data-content="${targetId}"]`);

            if (!content) return;

            const isActive = button.classList.contains('active');

            // 切换状态
            button.classList.toggle('active');
            content.classList.toggle('active');

            // 更新 ARIA
            button.setAttribute('aria-expanded', !isActive);

            // 展开底边距逻辑：展开时隐藏下方菜单项
            const menuItem = button.closest('.mobile-menu-item');
            if (menuItem) {
                handleExpandedMenuScroll(menuItem, content, !isActive);
            }
        });
    });

    // 展开底边距逻辑：控制下方菜单项的显示/隐藏
    function handleExpandedMenuScroll(expandedMenuItem, expandedContent, isExpanding) {
        const allMenuItems = document.querySelectorAll('.mobile-menu-item');
        const expandedIndex = Array.from(allMenuItems).indexOf(expandedMenuItem);

        // 获取展开项下方的所有菜单项
        const siblingItems = Array.from(allMenuItems).slice(expandedIndex + 1);

        if (isExpanding) {
            // 展开时：隐藏下方菜单项
            siblingItems.forEach(item => {
                item.classList.add('hidden-below-expanded');
            });

            // 监听展开内容的滚动
            expandedContent.addEventListener('scroll', function onScroll() {
                const isAtBottom = expandedContent.scrollHeight - expandedContent.scrollTop <= expandedContent.clientHeight + 10;

                if (isAtBottom) {
                    // 滚动到底部，显示下方菜单项
                    siblingItems.forEach(item => {
                        item.classList.remove('hidden-below-expanded');
                    });
                } else {
                    // 未滚到底部，保持隐藏
                    siblingItems.forEach(item => {
                        item.classList.add('hidden-below-expanded');
                    });
                }
            });

            // 初始检查：如果内容不需要滚动（内容高度小于容器），直接显示
            setTimeout(() => {
                if (expandedContent.scrollHeight <= expandedContent.clientHeight + 10) {
                    siblingItems.forEach(item => {
                        item.classList.remove('hidden-below-expanded');
                    });
                }
            }, 100);
        } else {
            // 收起时：显示所有菜单项
            siblingItems.forEach(item => {
                item.classList.remove('hidden-below-expanded');
            });
        }
    }

    // 智能滚动条显隐
    if (drawerContent) {
        let scrollTimeout;

        drawerContent.addEventListener('scroll', () => {
            drawerContent.classList.add('scrolling');

            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                drawerContent.classList.remove('scrolling');
            }, 2000); // 2秒后隐藏
        });
    }

})();
